<template>
    <modal dir="ltr" name="modal-extra" :width="330" :height="'auto'" scrollable @before-open="beforeOpen" style="z-index: 1200!important;">
        <div class="text-center border rounded-lg bg-white p-5">
            <div class="text-xl font-medium">{{ showTitle() }}</div>
            <div class="text-xs text-gray-700 my-3" v-html="this.$root.getLangObject(is_16 === true ? this.$root.hotel.is_16_text : this.$root.hotel.is_adult_text)">
            </div>
            <div>
                <button @click="yes" class="py-1 px-4 w-24 rounded text-white bg-green-500 hover:bg-green-700 mr-4">
                    {{ $root.getKeyWord('yes') }}
                </button>
                <button @click="$modal.hide('modal-extra')"
                        class="py-1 px-4 w-24 rounded text-white bg-gray-500 hover:bg-gray-700">
                    {{ $root.getKeyWord('no') }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import {SectionRouter} from '@/components/mixins/SectionRouter';

export default {
    mixins: [SectionRouter],
    data() {
        return {
            item: null,
            section_id: null,
            beerSections: [6958, 6993],
            is_16: false
        }
    },

    methods: {
        beforeOpen(event) {
            this.item = event.params.item;
            this.section_id = event.params.section_id;
        },

        yes() {
            if (this.$root.hotelCode == 'novotelgenevecentre' && this.item != null && this.beerSections.includes(this.item.section_id)) {
                localStorage.setItem('is_16', true);
            }
            else{
                localStorage.setItem('is_16', true);
                localStorage.setItem('is_adult', true);
            }

            if (this.item && this.section_id == null) {
              this.$parent.showCart(this.item);
            }
            this.$modal.hide('modal-extra');

            if (this.section_id !== null) {
                this.routeSectionLink(this.item);
            }
        },

        showTitle() {
            let title = this.$root.getKeyWord('is_adult');
            if (this.$root.hotelCode == 'novotelalmaty' || this.$root.hotelCode == 'swissoteltashkent') {
                title = title.replace("18", "21")
                    .replace("лет", "год");
            }
            if (this.$root.hotelCode == 'novotelgenevecentre' && this.item != null && this.beerSections.includes(this.item.section_id)) {
                title = title.replace("18", "16");
                this.is_16 = true;
            }
            return title;
        }
    }
}
</script>